import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Button, Grid } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import copy from 'copy-to-clipboard'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import IconButton from '@material-ui/core/IconButton'

const useStyles = makeStyles((theme: Theme) => ({
  buttonsTheme: {
    padding: theme.spacing(6, 6, 4, 4),
  },
  buttonpadding: {
    marginRight: theme.spacing(4),
  },
  title: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightBold,
    marginTop: theme.spacing(4),
    paddingLeft: theme.spacing(2),
  },
  container: {
    wordBreak: 'break-all',
    padding: theme.spacing(0, 2, 0, 2),
  },
  closeIcon: {
    position: 'absolute',
    right: theme.spacing(4),
    top: theme.spacing(4),
    color: 'black',
  },
  dialog: {
    height: theme.spacing(100),
    overflow: 'hidden',
  },
}))

interface SequenceViewModel {
  dialogOpen: boolean
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
  item: any
}

const SequenceViewModel: FC<SequenceViewModel> = (props) => {
  const classes = useStyles()
  const { dialogOpen, setDialogOpen, item } = props

  const handleClose = () => {
    setDialogOpen(false)
  }

  return (
    <Dialog
      onClose={handleClose}
      aria-label="view the ORF sequence"
      open={dialogOpen}
      maxWidth="md"
      classes={{ paperScrollPaper: classes.dialog }}
    >
      <DialogTitle>
        <h4 id="simple-modal-title" className={classes.title}>
          {item !== undefined ? item.cloneId : ''}{' '}
          <FormattedMessage
            id="SEMICONFIGURATOR_ORF_SEQUENCE"
            defaultMessage=" ORF SEQUENCE"
          />
        </h4>
      </DialogTitle>
      <IconButton className={classes.closeIcon} onClick={handleClose}>
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <p id="simple-modal-description" className={classes.container}>
          {item !== undefined ? item.orfSequence : ''}
        </p>
      </DialogContent>
      <DialogActions>
        <Grid container className={classes.buttonsTheme} alignItems="center">
          <Grid item style={{ marginLeft: 'auto' }}>
            <Button
              onClick={handleClose}
              color="primary"
              id="close-button"
              data-testid="close-button"
              variant="outlined"
              className={classes.buttonpadding}
            >
              <FormattedMessage
                id="CONF_CLOSE_BUTTON"
                defaultMessage="Close "
              />
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => copy(item.orfSequence)}
              color="primary"
              variant="contained"
              id="copy-sequence-button"
              data-testid="copy-sequence-button"
            >
              <FormattedMessage
                id="SEMI_CONF_COPY_TO_CLIPBOARD"
                defaultMessage="Copy To Clipboard"
              />
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  )
}

export default SequenceViewModel
